import { LoadingSpinner, Typography } from '@neo4j-ndl/react';
import { CheckCircleIconSolid, XCircleIconSolid } from '@neo4j-ndl/react/icons';
import { PROGRESS_STATUS, type ProgressEvent } from '@nx/state/desktop';

export const ProgressStep = ({ step }: { step: ProgressEvent }) => {
  if (step.status === PROGRESS_STATUS.SUCCESS) {
    return (
      <div className="flex gap-3">
        <CheckCircleIconSolid className="size-token-7 fill-success-icon" />
        <Typography variant="body-large">{step.message}</Typography>
      </div>
    );
  }

  if (step.status === PROGRESS_STATUS.LOADING) {
    return (
      <div className="flex gap-3">
        <LoadingSpinner size="medium" />
        <Typography variant="body-large">{step.message}</Typography>
      </div>
    );
  }

  return (
    <div className="flex gap-3">
      <XCircleIconSolid className="size-token-7 fill-danger-icon" />
      <Typography variant="body-large">{step.message}</Typography>
    </div>
  );
};
